module.exports = __webpack_public_path__ + "img/10-alliances-for-gender-just.d15d71f9.png";